import qs from 'qs';
import { client } from '@/client';

let controller;

// 取消日志请求
export const abortRunningLogRequest = () => {
  if (controller) {
    controller.abort();
  }
};

// 获取集群基本状态数量 在线、离线
export function getAllClusterSize() {
  return client.get('/api/console/cluster/getAllClusterSize');
}

// 集群列表
export function getClusterList(params) {
  return client.get('/api/metrics/cluster/list', params);
}

// 新增接入集群
export function addCluster(params) {
  return client.post('/api/resource/cluster/addCluster', params);
}

// 删除集群
export function deleteCluster(clusterName) {
  return client.delete('/api/resource/cluster/deleteCluster', { clusterName });
}

export function onlineCluster(clusterName) {
  return client.put(
    `/api/resource/cluster/onlineCluster${qs.stringify({ clusterName }, { addQueryPrefix: true })}`,
    { clusterName },
  );
}

export function offlineCluster(clusterName) {
  return client.put(
    `/api/resource/cluster/offlineCluster${qs.stringify(
      { clusterName },
      { addQueryPrefix: true },
    )}`,
    { clusterName },
  );
}

// 更新集群
export function updateCluster(params) {
  return client.post('/api/resource/cluster/updateCluster', params);
}

// 查询详情
export function getClusterInfo(clusterName) {
  return client.get('/api/resource/cluster/getClusterInfo', { clusterName });
}

// 获取集群详情
export function getClusterDetailByName(name) {
  return client.get(`/api/metrics/cluster/${name}`);
}

// 获取健康度状态结果
export function getInspectionRuleExecuteResults(params) {
  return client.get('/api/console/healthcheck/getInspectionRuleExecuteResults', params);
}

// 获取所有健康度配置
export function getAllInspectionRules(clusterType) {
  return client.get('/api/console/healthcheck/getAllInspectionRules', { clusterType });
}

// 获取历史事件
export function getAllClusterHistories(params) {
  return client.post(`/api/audit_log/history-query`, params);
}

// 获取图表数据
export function getChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/cluster/${clusterName}`, others);
}

// 异常健康度详情
export function getUnhealthResultDetail(params) {
  return client.get('/api/console/healthcheck/getUnhealthResultDetail', params);
}

// 校验 pulsar client 地址
export function validatePulsarClient(params) {
  return client.get('/api/url/verify/pulsarClient', params);
}
// 校验 pulsar admin 地址
export function validatePulsarAdmin(params) {
  return client.get('/api/url/verify/pulsarAdmin', params);
}

// 校验 prometheusUrl 地址
export function validatePrometheus(params) {
  return client.get('/api/url/verify/prometheusUrl', params);
}

// 校验 kop 地址
export function validateKop(params) {
  return client.get('/api/url/verify/kop', params);
}

// 校验grafana地址
export function validateGrafana(params) {
  return client.get('/api/url/verify/grafana', params);
}
// 校验 bookieAdmin 地址
export function validateBookieAdmin(params) {
  return client.get('/api/url/verify/bookieAdmin', params);
}

// 校验
export function validatePulsarFunction(params) {
  return client.get('/api/url/verify/pulsarFunction', params);
}

// Geo 列表
export function getGeoList(clusterName) {
  return client.get(`/api/metrics/geo/cluster/list/${clusterName}`);
}

export function createGeo(params) {
  return client.put('/api/resource/geo/cluster/addReplicationCluster', params);
}

// Geo相关参数带出
export function getGeoParams(params) {
  const { clusterName, ...others } = params;
  return client.get(
    `/api/metrics/geo/cluster/getAddReplicationClusterParam/${clusterName}`,
    others,
  );
}

// 更新GEO
export function updateGeo(params) {
  return client.put('/api/resource/geo/cluster/updateReplicationCluster', params);
}

// 删除GEO
export function deleteGeo(params) {
  const { clusterName, ...others } = params;
  return client.delete(`/api/resource/geo/cluster/deleteReplicationCluster/${clusterName}`, others);
}

// GEO集群详情
export function getGeoDetail(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/geo/cluster/data/${clusterName}`, others);
}

export function getAllClusterEnvs() {
  return client.get('/api/console/env/getAllClusterEnvs');
}

// 日志列表
export function getLogFileList(params) {
  const { clusterName, host, ...others } = params;
  return client.get(`/api/log/getLogFileList/${clusterName}/${host}`, others);
}

// 日志详情数据
export function getRunningLog(params) {
  controller = new AbortController();
  const { clusterName, host, ...others } = params;
  return client.get(`/api/log/getRunningLog/${clusterName}/${host}`, others, {
    signal: controller.signal,
  });
}

// 检查备集群topic
export function checkDisasterRecoveryCluster(params) {
  return client.put('/api/recovery/recoveryCluster/check', params);
}

// 获取检查进度
export function getRecoveryClusterCheckInfo(primaryClusterName) {
  return client.get('/api/recovery/recoveryCluster/check/process', { primaryClusterName });
}

// 备集群topic修复
export function handleErrorTopicService(params) {
  return client.post('/api/recovery/recoveryCluster/repair', params);
}

// 获取管理员列表
export function getClusterAdminList(params) {
  return client.get('/api/sys_user_service/listClusterAdminUser', params);
}
